import React from 'react';

const Settings = () => {
  return (
    <div className='w-screen h-screen flex items-center flex-col align-center'>
      <h1>Settings Page</h1>
      <p>This is the settings page.</p>
    </div>
  );
};

export default Settings;